import React from 'react';
import './QuestionNavigator.css';

const QuestionNavigator = ({
  count,
  currentIndex,
  onSelect,
  getStatus,
  title,
  subtitle,
  progress,
  legend,
  columns = 5,
  className = '',
  children,
}) => {
  return (
    <aside className={`single-question-sidebar ${className}`.trim()}>
      {title && <div className="sidebar-section-title">{title}</div>}
      {subtitle && <div className="sidebar-mock-name">{subtitle}</div>}
      {progress && (
        <>
          <div className="sidebar-progress">{progress.label}</div>
          <div className="question-progress-track">
            <div className="question-progress-fill" style={{ width: `${progress.percent}%` }} />
          </div>
        </>
      )}
      <div className="question-nav-grid" style={{ '--qn-columns': columns }}>
        {Array.from({ length: count }, (_, index) => {
          const status = getStatus ? getStatus(index) : '';
          const current = index === currentIndex;
          return (
            <button
              type="button"
              key={index}
              className={`question-nav-btn ${status} ${current ? 'current' : ''}`.trim()}
              onClick={() => onSelect(index)}
            >
              {index + 1}
            </button>
          );
        })}
      </div>
      {legend && (
        <div className="question-nav-legend">
          {legend.map((item) => (
            <div key={item.status || item.label}>
              <span className={`legend-dot ${item.status}`.trim()}></span> {item.label}
            </div>
          ))}
        </div>
      )}
      {children}
    </aside>
  );
};

export default QuestionNavigator;
